import { render, staticRenderFns } from "./compositePaymentItems.vue?vue&type=template&id=68041796&scoped=true&"
import script from "./compositePaymentItems.vue?vue&type=script&lang=js&"
export * from "./compositePaymentItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68041796",
  null
  
)

export default component.exports